// extracted by mini-css-extract-plugin
module.exports = {"statusWrapper":"global_statusWrapper__ZVIAB","animName":"global_animName__cat4U"};